/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const InvoiceStatus = {
    Unknown: 'unknown',
    Outstanding: 'outstanding',
    Matched: 'matched'
};
export function instanceOfInvoiceStatus(value) {
    for (const key in InvoiceStatus) {
        if (Object.prototype.hasOwnProperty.call(InvoiceStatus, key)) {
            if (InvoiceStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function InvoiceStatusFromJSON(json) {
    return InvoiceStatusFromJSONTyped(json, false);
}
export function InvoiceStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InvoiceStatusToJSON(value) {
    return value;
}
export function InvoiceStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
